import { useFrame } from '@react-three/fiber';
import { useRef } from 'react';
import { setWebGLInstance, pushFrameDelta } from './LabMonitor';

export const WebGLCapture: React.FC = () => {
  const captured = useRef(false);

  useFrame((state, delta) => {
    if (!captured.current && state.gl) {
      setWebGLInstance(state.gl);
      captured.current = true;
    }
    pushFrameDelta(delta);
  });

  return null;
};
